import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { KitService } from "src/shared/kit.service";
import { FavieTranslateService } from "src/shared/translate/servives/favie-translate.service";
import { PRODUCT_PRICE_CONST } from '../../asset/constants/product-price.constant';

@Component({
  selector: "app-preorder",
  templateUrl: "./preorder.component.html",
  styleUrls: ["./preorder.component.scss"],
})
export class PreorderComponent implements OnInit {
  @ViewChild("pdfTable") pdfTable: ElementRef;

  shirt;
  short;
  socks;
  noNumber;
  noName;
  image;
  nameColor;
  uploadedImages = "";

  displayShirtMessage: boolean;
  displayShortMessage: boolean;
  displaySocksMessage: boolean;

  shirtInput: number;
  shortInput: number;
  socksInput: number;

  shirtTotalPrice: number = 0;
  shortTotalPrice: number = 0;
  socksTotalPrice: number = 0;
  kitTotalAmount: number;
  shirtColor;
  shortColor;

  constructor(
    private http: HttpClient,
    private kitService: KitService,
    private readonly router: Router,
    private translate: FavieTranslateService
  ) {}

  ngOnInit(): void {
    this.shirt = this.kitService.getJersey();
    this.short = this.kitService.getShort();
    this.socks = this.kitService.getSocks();
    this.noNumber = "Non";
    this.shirtInput = 10;
    this.shortInput = 10;
    this.socksInput = 10;
    this.displayShirtMessage = false;
    this.displayShortMessage = false;
    this.displaySocksMessage = false;
    this.shirtColor = this.shirt.couleur_fond.match(/[A-Z][a-z]+|[0-9]+/g).join(" ");
    this.shortColor = this.short ? this.short.couleur.match(/[A-Z][a-z]+|[0-9]+/g).join(" ") : ''

    if (this.kitService.isNoNumber()) {
      this.noNumber = "Oui";
    }

    this.noName = "Non";
    if (this.kitService.isNoName()) {
      this.noName = "Oui";
    }

    this.image = this.kitService.getJerseyImages();
    if (!this.image) {
      this.image = {
        heartImage: "",
        frontImage: "",
        leftImage: "",
        rightImage: "",
        backImage: "",
      };
    }

    var filteredImages = Object.assign(
      {},
      ...Object.entries(this.image)
        .filter(([k, v]) => v != "" && k != "shortImage")
        .map(([k, v]) => ({ [this.translate.instant(k.replace('Image', ''))]: v }))
    );
    if (filteredImages) {
      this.uploadedImages = Object.keys(filteredImages).join(', ');
    }
    this.nameColor = this.kitService.getColorName();
    if (this.shirt) {
      this.shirtTotalPrice = this.shirt.maillot_modele.price * 10;
    }
    if (this.short) {
      this.shortTotalPrice = this.short.short_modele.price * 10;
    }
    if (this.socks) {
      this.socksTotalPrice = this.socks.prix * 10;
    }
    this.totalKitPrice();
  }

  decrementShirt() {
    this.shirtInput = this.shirtInput - 1;

    if (this.shirtInput < 0) {
      this.shirtInput = 0;
    }

    if (this.shirtInput > 9) {
      this.displayShirtMessage = false;
    } else if (this.shirtInput < 10) {
      this.displayShirtMessage = true;
    }

    this.shirtTotalPrice = this._managePriceOnQuantity(this.shirtInput, this.shirt.maillot_modele);
    this.totalKitPrice();
  }
  incrementShirt() {
    this.shirtInput++;

    if (this.shirtInput > 9) {
      this.displayShirtMessage = false;
    } else if (this.shirtInput < 10) {
      this.displayShirtMessage = true;
    }
    this.shirtTotalPrice = this._managePriceOnQuantity(this.shirtInput, this.shirt.maillot_modele);
    this.totalKitPrice();
  }
  decrementShort() {
    this.shortInput = this.shortInput - 1;

    if (this.shortInput < 0) {
      this.shortInput = 0;
    }

    if (this.shortInput > 9) {
      this.displayShortMessage = false;
    } else if (this.shortInput < 10) {
      this.displayShortMessage = true;
    }

    this.shortTotalPrice = this._managePriceOnQuantity(this.shortInput, this.short.short_modele);
    this.totalKitPrice();
  }
  incrementShort() {
    this.shortInput++;

    if (this.shortInput > 9) {
      this.displayShortMessage = false;
    } else if (this.shortInput < 10) {
      this.displayShortMessage = true;
    }

    this.shortTotalPrice = this._managePriceOnQuantity(this.shortInput, this.short.short_modele);
    this.totalKitPrice();
  }

  decrementSocks() {
    this.socksInput = this.socksInput - 1;

    if (this.socksInput < 0) {
      this.socksInput = 0;
    }

    if (this.socksInput > 9) {
      this.displaySocksMessage = false;
    } else if (this.socksInput < 10) {
      this.displaySocksMessage = true;
    }
    this.socksTotalPrice = this._managePriceOnQuantity(this.socksInput, this.socks);
    this.totalKitPrice();
  }
  incrementSocks() {
    this.socksInput++;

    if (this.socksInput > 9) {
      this.displaySocksMessage = false;
    } else if (this.socksInput < 10) {
      this.displaySocksMessage = true;
    }
    this.socksTotalPrice = this._managePriceOnQuantity(this.socksInput, this.socks);
    this.totalKitPrice();
  }

  shirtInputChange(event) {
    this.shirtInput = event.target.value;
    this.displayShirtMessage = this.shirtInput <= 9;
    this.shirtTotalPrice = this._managePriceOnQuantity(this.shirtInput, this.shirt.maillot_modele);
    this.totalKitPrice();
  }

  shortInputChange(event) {
    this.shortInput = event.target.value;
    this.displayShortMessage = this.shortInput <= 9;
    this.shortTotalPrice = this._managePriceOnQuantity(this.shortInput, this.short.short_modele);
    this.totalKitPrice();
  }

  socksInputChange(event) {
    this.socksInput = event.target.value;
    this.displaySocksMessage = this.socksInput <= 9;
    this.socksTotalPrice = this._managePriceOnQuantity(this.socksInput, this.socks);
    this.totalKitPrice();
  }

  totalKitPrice() {
    this.kitTotalAmount =
      this.shirtTotalPrice + this.shortTotalPrice + this.socksTotalPrice;
    this.kitService.setQuantities(
      this.shirtInput,
      this.shortInput,
      this.socksInput
    );
  }

  goToQuotation() {
    this.router.navigate(["/contact-info", "quotation"]);
  }

  keepForLater() {
    this.router.navigate(["/contact-info", "later"]);
  }

  getAdvice() {
    this.router.navigate(["/contact-info", "advice"]);
  }

  back() {
    this.router.navigate(["/summary"]);
  }

  private _managePriceOnQuantity(quantity, product) {
    let _totalPrice;
    if (quantity <= PRODUCT_PRICE_CONST.ProductQuantityOne) {
      _totalPrice = quantity * product.price;
    } else if (
      quantity <= PRODUCT_PRICE_CONST.ProductQuantityTwo &&
      quantity > PRODUCT_PRICE_CONST.ProductQuantityOne) {
      _totalPrice = quantity * product.price_2;
    } else if (
      quantity <= PRODUCT_PRICE_CONST.ProductQuantityThree &&
      quantity > PRODUCT_PRICE_CONST.ProductQuantityTwo) {
      _totalPrice = quantity * product.price_3;
    } else if (quantity > PRODUCT_PRICE_CONST.ProductQuantityThree) {
      _totalPrice = quantity * product.price_4;
    }
    return _totalPrice;
  }

}
